import { Grid } from '@mui/material';
import { Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateGuiVersionType } from 'types/compobotGuiVersion.type';
import FormField from '../FormField';

interface DisplayDateSectionProps {
  control: Control<CreateGuiVersionType>;
  errors: FieldErrors<CreateGuiVersionType>;
}

export default function DisplayDateSection({
  control,
  errors,
}: DisplayDateSectionProps) {
  const { t } = useTranslation();

  const dateRules = {
    required: t('createGuiVersionPage.from') + ' kötelező',
  };

  return (
    <>
      <Grid item xs={12}>
        {/* <Typography variant="subtitle1" sx={{ mt: 3, mb: 1 }}>
          {t('createGuiVersionPage.displayDate')}
        </Typography> */}
      </Grid>
      <Grid item xs={6}>
        <FormField
          name="from"
          control={control}
          errors={errors}
          label={t('createGuiVersionPage.from')}
          type="date"
          rules={dateRules}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <FormField
          name="to"
          control={control}
          errors={errors}
          label={t('createGuiVersionPage.to')}
          type="date"
          rules={dateRules}
          fullWidth
        />
      </Grid>
    </>
  );
}
